'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Attention = require('./Attention');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Attention).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Attention/index.js
// module id = 1114
// module chunks = 1